import React from "react";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Delete32 from "@carbon/icons-react/lib/delete/32";
import { IconButton } from "@prestosports/commons-ui";
import Box from "@material-ui/core/Box";
import { SupervisorAccountRounded } from "@material-ui/icons";
import Personnel from "./Personnel";
import personnelListStyles from "../styles/sports/PersonnelList.styles";
import commonStyles from "../styles/Common.styles";

const PersonnelList = ({ personnel = [], roles = [], onChange, onDelete }) => {
	const classes = personnelListStyles();
	const commonClasses = commonStyles();

	return personnel.length ? (
		<List disablePadding>
			{personnel.map((p, index) => (
				<ListItem key={p.id} disableGutters className={classes.listItem}>
					<Personnel personnel={p} roles={roles} onChange={onChange} />
					<IconButton
						aria-label="Delete personnel"
						id={`icon-button-delete-${index}`}
						onClick={() => onDelete(p)}
					>
						<Delete32 />
					</IconButton>
				</ListItem>
			))}
		</List>
	) : (
		<Box
			alignItems="center"
			display="flex"
			flexDirection="column"
			justifyContent="center"
			className={commonClasses.container}
		>
			<SupervisorAccountRounded className={commonClasses.contentCenteredIcon} />
		</Box>
	);
};

export default PersonnelList;
